import React from "react";
import tossRun from "../../assets/toss_running.jpeg";
import "./FirstSectionStyles.css";
import { AiFillCaretRight } from "react-icons/ai";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import { useEffect } from "react";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const FirstSection = () => {
  const { t } = useTranslation("common");
  const slideInLeft = (elem) => {
    gsap.fromTo(
      elem,

      {
        x: -40,
        opacity: 0,
      },
      {
        opacity: 1,
        x: 0,
        duration: 1,
        scrollTrigger: {
          trigger: elem,
          start: "top center",
          end: "bottom center",

          toggleActions: "play none none none",
        },
      }
    );
  };
  const slideInRight = (elem) => {
    gsap.fromTo(
      elem,

      {
        x: 40,
        opacity: 0,
      },
      {
        opacity: 1,
        x: 0,
        duration: 1,
        scrollTrigger: {
          trigger: elem,
          start: "top center",
          end: "bottom center",

          toggleActions: "play none none none",
        },
      }
    );
  };

  const slideInBottom = (elem) => {
    gsap.fromTo(
      elem,

      {
        y: 40,
        opacity: 0,
      },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        scrollTrigger: {
          trigger: elem,
          start: "top center",
          end: "bottom center",

          toggleActions: "play none none none",
        },
      }
    );
  };

  useEffect(() => {
    if (!isMobile) {
      slideInLeft("#first-section-image");
      slideInRight("#first-section-texte");
    } else {
      slideInBottom("#first-section-image");
      slideInBottom("#first-section-texte");
    }
  }, []);

  return (
    <div className="first-section">
      <div className="first-section-image" id="first-section-image">
        <img  src={tossRun} alt="" />
      </div>
      <div className="first-section-texte" id="first-section-texte">
        <h5> Toss 2026 : 8, 9 et 10 Mai 2026</h5>

        <h2> {t("home.edition")}</h2>
        <h3> {t("home.section1_subtitle")}</h3>

        <p> {t("home.section1_texte1")}</p>
        <p> {t("home.section1_texte2")}</p>

        <a
          href="https://toss-register.bds-cs.fr/register"
          className="btn-first-section"
        >
          {t("home.inscrire")} <AiFillCaretRight className="fleche" />{" "}
        </a>
      </div>
    </div>
  );
};

export default FirstSection;
